const url = window.location.href;

/* DEBUG MODE */
const hasDebugParam = url.includes("debug=1");
if(hasDebugParam) {
  document.querySelectorAll('.multistep-card').forEach(step => {
    step.style.height = "auto";
    if( step.classList.contains('hidden') || step.classList.contains('hide') ){
      step.style.display = 'block';
      step.style.animation = 'none';
    }
    step.querySelectorAll('[data-hidden]').forEach( hiddenElem => { hiddenElem.style.display = 'block' })
  })
  document.querySelector('.bundle-results').classList.add('bundle-results--visible')
  document.querySelector('.multistep-card--join').style.display = 'none'
}

const multiStepForm = document.querySelector("[data-multi-step]")
const formSteps = [...multiStepForm.querySelectorAll("[data-step]")] 
let currentStep = formSteps.findIndex(step => {
  return step.classList.contains("active")
})

const stepAges = multiStepForm.querySelectorAll('[name="ages"]')
var selectedAge =  (multiStepForm.querySelector('[name="ages"]:checked'))?multiStepForm.querySelector('[name="ages"]:checked').value:null
const stepSizes = multiStepForm.querySelectorAll('[name="sizes"]')
var selectedSize = (multiStepForm.querySelector('[name="sizes"]:checked'))?multiStepForm.querySelector('[name="sizes"]:checked').value:null
const stepDeliveries = multiStepForm.querySelectorAll('[name="deliveries"]')
var selectedDelivery =  (multiStepForm.querySelector('[name="deliveries"]:checked'))?multiStepForm.querySelector('[name="deliveries"]:checked').value:null

const bundleResults = document.querySelector('.bundle-results')
const results = bundleResults.querySelectorAll('.multistep-result')

const addAll = document.querySelector('.button--add-all')

formSteps.forEach( formStep => { formStep.classList.remove("hidden") })
bundleResults.querySelector('[data-step]').classList.remove("hidden")

function setDefaultValues(){
  console.log('setDefaultValues') 
  stepAges[0].click()
  stepAges[0].dispatchEvent(new Event('change', { bubbles: true }))

  stepSizes[0].click()
  stepSizes[0].dispatchEvent(new Event('change', { bubbles: true }))

  stepDeliveries[stepDeliveries.length - 1].click()
  stepDeliveries[stepDeliveries.length - 1].dispatchEvent(new Event('change', { bubbles: true }))
}

//document.addEventListener('DOMContentLoaded', () => {
window.onload = function() {
  console.log('DOMContentLoaded') 
  setDefaultValues();
};

//STEP 1: changes on Age 
stepAges.forEach( stepAge => {
  stepAge.addEventListener('change', () => {    
    selectedAge =  multiStepForm.querySelector('[name="ages"]:checked').value
    let sizesByAge = stepAge.dataset.sizes.split(",")

    selectedDelivery = Array.from(stepDeliveries).find( stepDelivery => {return stepDelivery.checked == true} )?.value

    //show corresponding sizes on step 2
    stepSizes.forEach( stepSize => {
      stepSize.nextElementSibling.style.display = 'none'
      if(selectedDelivery != "trial" && sizesByAge.includes(stepSize.value)){
        stepSize.nextElementSibling.style.display = 'block'
        stepSize.checked = true
        stepSize.dispatchEvent(new Event('change', { bubbles: true }))
      } else {
        stepSize.nextElementSibling.style.display = 'none'
        stepSize.checked = false
      }
    })
    //changing informative text based on the selection
    let recommendedSize = multiStepForm.querySelector('[name="ages"]:checked').dataset.recommended
    let recommendedAmount = multiStepForm.querySelector('[name="ages"]:checked').dataset.daily
    document.querySelectorAll('.multistep-changeable[data-daily]').forEach(recommended => { recommended.innerHTML = recommendedAmount })
    //change .multistep-changeable[data-recommended-size] with data-sizes from age
    document.querySelector('.multistep-changeable[data-recommended-size]').innerHTML = recommendedSize
  })
})

//STEP 2: changes on Size
stepSizes.forEach( stepSize => {
  stepSize.addEventListener('change', () => {
    selectedDelivery = Array.from(stepDeliveries).find( stepDelivery => {return stepDelivery.checked == true} )?.value
    selectedSize = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} )?.value

    //show/hide/disable/enable products that do not have that size
    //change selected value in the size dropdown (size variant) for all results (products), so the right variant can be selected
    results.forEach( result => {
      let resultSizes = result.dataset.sizes;

      //change the number of packs based on size and data-2w, 4w, 6w, trial depending on what the user selected
      var frequency = "trial"
      var numberOfPacks = "Single"
      var wipes = "trial"
      var numberOfWipes = "Single"
      if(selectedDelivery != "1"){
        frequency = selectedDelivery + "w"
        wipes = "wipes" + frequency
      }
      numberOfPacks = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} ).dataset[frequency]
      numberOfWipes = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} ).dataset[wipes]

      //console.log("frequency/numberOfPacks:", frequency+"/"+numberOfPacks, "wipes/numberOfWipes",wipes+"/"+numberOfWipes)
      
      //select the right pack
      let packs = result.querySelector('[name="options[Packs]"]:not(.wipes-packs)')
      if(packs){
        packs.value = Array.from(packs).find( pack => { return pack.value.includes(numberOfPacks) } )?.value      
        packs.dispatchEvent(new Event('change', { bubbles: true }))
        //console.log("Packs changed to: " + Array.from(packs).find( pack => { return pack.value.includes(numberOfPacks) } )?.value )
      }
      let packsWipes = result.querySelector('.wipes-packs[name="options[Packs]"]')
      if(packsWipes){
        packsWipes.value = packsWipes.querySelector(`option[value*="${numberOfWipes}"]`)?.value;
        packsWipes.dispatchEvent(new Event('change', { bubbles: true }))
        //console.log("PacksWipes changed to: " + packsWipes.querySelector(`option[value*="${numberOfWipes}"]`)?.value)
      }
      let sizes = result.querySelector('[name="options[Size]"]')
      if(sizes){
        sizes.value = Array.from(sizes).find( size => { return size.value.includes("Size " + selectedSize) } )?.value        
        sizes.dispatchEvent(new Event('change', { bubbles: true }))
      }
      document.querySelectorAll('.multistep-changeable[data-right-size]').forEach(rightSize => { rightSize.innerHTML = selectedSize })
    
      //contains selected size
      if(result.dataset.product != "trial" && resultSizes && resultSizes.split(",").includes(selectedSize) && selectedDelivery != "1" ){
        result.querySelector('fieldset').disabled = false;
        result.style.display = "block";        
      }

      //trial bundle has all sizes, but only shows if selectedDelivery = 1 (trial)
      if(selectedDelivery == "1" && result.dataset.product == "trial"){
        result.querySelector('fieldset').disabled = false;
        result.style.display = "block"
      }
      //is trial bundle and trial is not selected
      if(selectedDelivery != "1" && result.dataset.product == "trial"){
        //hide
        result.querySelector('fieldset').disabled = true;
        result.style.display = "none"
      }      
      
      //result does not contain selected size
      if( (selectedDelivery == "1" && result.dataset.product != "trial") || (result.dataset.product != "trial" && resultSizes && !resultSizes.split(",").includes(selectedSize))  ){
        result.querySelector('fieldset').disabled = true;
        result.style.display = "none"
      }
    })  
    
    //change .multistep-changeable[data-right-size] with the selected size 
    //change .multistep-changeable[data-months] with the selected data-months from the selected age 

  })
})

//STEP 3: changes on Deliveries (Frequency)
stepDeliveries.forEach( stepDelivery => {
  stepDelivery.addEventListener('change', () => {
    //change frequency dropdown for all results
    selectedDelivery = Array.from(stepDeliveries).find( stepDelivery => {return stepDelivery.checked == true} )?.value
    selectedSize = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} )?.value
          
    results.forEach( result => {
      const frequencies = result.querySelector('[name="frequencies"]')
      const packs = result.querySelector('[name="options[Packs]"]')
      const purchaseTypes = result.querySelector('[name="purchase-type"]')
      /*
      const packs = result.querySelector('[name="options[Packs]"]:not(.wipes-packs)')
      const wipesPacks = result.querySelector('[name="options[Packs]"].wipes-packs')
      */
      
      //selecting one-off (trial) needs to select Purchase Type = One-off for all results; selecting anything else changes Purchase Type = Subscription
      //if Subs then set the frequency
      
      //change the number of packs based on size and data-2w, 4w, 6w, trial depending on what the user selected
      if(selectedDelivery == 1){
        //IT IS A TRIAL
        /*
        if(purchaseTypes){
          purchaseTypes.value = "oneoff"
          purchaseTypes.dispatchEvent(new Event('change', { bubbles: true }))
          frequencies.disabled = true  
        }
        */
        //hide all and show trial bundles
        if(result.dataset.product == "trial"){
          result.style.display = "block"
          result.querySelector('fieldset').disabled = false;
        } else {
          result.style.display = "none"
          result.querySelector('fieldset').disabled = true;
        }
        //packs.value = "Single Pack"
        //purchaseTypes.dispatchEvent(new Event('change', { bubbles: true }))
      } else {
        //IT IS A SUBSCRIPTION
        let resultSizes = result.dataset.sizes;
        
        //show all except for trial
        if(result.dataset.product != "trial" && resultSizes.split(",").includes(selectedSize)){
          result.style.display = "block" 
          result.querySelector('fieldset').disabled = false;
        } else {
          result.style.display = "none"
          result.querySelector('fieldset').disabled = true;
        }
        //set the type to Subscription
        if(purchaseTypes){
          purchaseTypes.value = "subscription"
          purchaseTypes.dispatchEvent(new Event('change', { bubbles: true }))
        }
        if(frequencies) frequencies.disabled = false

        //change the number of packs based on size and data-2w, 4w, 6w, trial depending on what the user selected
        var frequency = "trial"
        var numberOfPacks = "Single"
        var wipes = "trial"
        var numberOfWipes = "Single"
        
        if(selectedDelivery != "1"){
          frequency = selectedDelivery + "w"
          wipes = "wipes" + selectedDelivery + "w"
        }
        numberOfPacks = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} ).dataset[frequency]
        numberOfWipes = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} ).dataset[wipes]

        //select the right pack
        let packs = result.querySelector('[name="options[Packs]"]:not(.wipes-packs)')
        if(packs){
          packs.value = Array.from(packs).find( pack => { return pack.value.includes(numberOfPacks) } )?.value      
          packs.dispatchEvent(new Event('change', { bubbles: true }))
  
          //console.log("Packs changed to: " + Array.from(packs).find( pack => { return pack.value.includes(numberOfPacks) } )?.value )
        }
        let packsWipes = result.querySelector('.wipes-packs[name="options[Packs]"]')
        if(packsWipes){
          packsWipes.value = packsWipes.querySelector(`option[value*="${numberOfWipes}"]`).value;
          packsWipes.dispatchEvent(new Event('change', { bubbles: true }))
  
          //console.log("PacksWipes changed to: " + packsWipes.querySelector(`option[value*="${numberOfWipes}"]`).value)
        }   
        
        if(!frequencies) return
        frequencies.value = Array.from(frequencies).find( frequency => { return frequency.value === selectedDelivery } )?.value
        frequencies.dispatchEvent(new Event('change', { bubbles: true }))

        //const selectedAge =  multiStepForm.querySelector('[name="ages"]:checked')
        //packs.value = Array.from(packs).find( pack => { return pack.value.includes(selectedDelivery) })?.value
        //packs.dispatchEvent(new Event('change', { bubbles: true }))
      }      
      
    })   
  })
})

//Add all to cart
addAll.addEventListener('click', () => {
  var cartItems = [];

  results.forEach( result => {
    if(!result.querySelector('fieldset').hasAttribute('disabled')){
      const variants = result.querySelector('[name="id"]')
      const sellingPlans = result.querySelector('[name="selling-plans"]')
      const quantity = result.querySelector('[name="quantity"]')
      //console.log('variants.value',variants.value,'sellingPlans.value',sellingPlans.value)
      
      let cartItem = {}
      if(sellingPlans && !sellingPlans.disabled && sellingPlans.value){
        cartItem = {
          id: variants.value,
          quantity: quantity.value,
          selling_plan: sellingPlans.value
        }
      } else {
        cartItem = {
          id: variants.value,
          quantity: quantity.value,
        }
      }
        
      cartItems.push(cartItem)
    }
  })
  var cartData = {
    items: cartItems,
    attributes:{
    } 
  };  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },        
    body: JSON.stringify(cartData)
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
    //console.log('Products added to cart:', data);
    //alert('Products added to cart')
    const cartNotification = document.querySelector('#cart-notification')
    if(cartNotification) {
      cartNotification.classList.add('active')
      cartNotification.classList.add('animate')
    }
  })
    /*
  .catch(function(error) {
    console.error('Error adding product to cart:', error);
  });
  */
})

/*These events control changes in the results themselves*/
results.forEach( result => {
  const packs = result.querySelector('[name="options[Packs]"]')
  const sizes = result.querySelector('[name="options[Size]"]')
  const variants = result.querySelector('[name="id"]')
  const frequencies = result.querySelector('[name="frequencies"]')
  const sellingPlans = result.querySelector('[name="selling-plans"]')
  const purchaseTypes = result.querySelector('[name="purchase-type"]')
  const price = result.querySelector('.multistep-result__price')
  const totalCount = result.querySelector('.multistep-result__total-count')
  const quantity = result.querySelector('[name="quantity"]')
  const buttonAtc = result.querySelector('.button--atc')
   
  if(!variants) return;

  if(packs){
    var selectedPack = packs.value
    
    //change pack => change selected variant
    packs.addEventListener('change', () => {
      selectedPack = packs.value
      selectedSize = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} )?.value
      let sizeToSelect = "Size " + selectedSize
      //checking if the user changed the size selection
      if(sizes && sizes.selectedIndex && sizes.selectedIndex >= 0){
        sizeToSelect = sizes.options[sizes.selectedIndex].value
      }
      if(sizes && packs) variants.value = Array.from(variants).find( variant => {return variant.dataset.size.includes(sizeToSelect) && variant.dataset.packs === selectedPack} )?.value
      if(!sizes) variants.value = Array.from(variants).find( variant => { return variant.dataset.packs === selectedPack } )?.value
      if(!packs) variants.value = Array.from(variants).find( variant => { return variant.dataset.size === sizeToSelect } )?.value
      variants.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  variants.addEventListener('change', (variant) => {
    const selectedVariant = result.querySelector('[name="id"] option:checked')
    if(!selectedVariant) return
    let variantPrice = selectedVariant.dataset.price
    let variantCompareAtPrice = selectedVariant.dataset.compareat
    const resultPrice = result.querySelector('.multistep-result__price')
    
    //adjusting the price if it is a subscription
    if(sellingPlans && purchaseTypes && purchaseTypes.value == "subscription"){
      const selectedPlan = result.querySelector('[name="selling-plans"] option:checked')
      if(selectedPlan.dataset.adjustment && selectedPlan.dataset.adjustment > 0) variantPrice = variantPrice * selectedPlan.dataset.adjustment 
    }

    if(variantCompareAtPrice) variantCompareAtPrice = window.moneyFormat.replace("{{amount}}",(variantCompareAtPrice / 100).toFixed(2))
    variantPrice = window.moneyFormat.replace("{{amount}}",(variantPrice / 100).toFixed(2))
  
    //change variant => change price
    resultPrice.innerHTML = (variantCompareAtPrice)?`<span class="price-strike">${variantCompareAtPrice}</span>${variantPrice}`:variantPrice;

    //change variant => change image
    const variantImage = variants.options[variants.selectedIndex].dataset.image
    if(variantImage) {
      const images = result.querySelectorAll('.multistep-result__images .multistep-result__image');
      let hasVisibleImage = false
      images.forEach( img => { img.classList.remove('multistep-result__image--active') } )
      images.forEach( image => {
        if(image.dataset.image == variantImage && !hasVisibleImage) {
          image.classList.add('multistep-result__image--active')
          hasVisibleImage = true
        }
      })
    }
    
    //change total amount of nappies
  })

  //size dropdown
  if(sizes){
    sizes.addEventListener('change', () => {
      if(packs) var selectedPack = packs.value
      
      selectedSize = Array.from(stepSizes).find( stepSize => {return stepSize.checked == true} )?.value
      let sizeToSelect = "Size " + selectedSize
      if(!sizes.selectedIndex || !sizes.options[sizes.selectedIndex]) return
      
      //console.log("KKK",result,"selectedSize",selectedSize,"sizes.selectedIndex",sizes.selectedIndex,"sizes.options[sizes.selectedIndex]",sizes.options[sizes.selectedIndex],"sizeToSelect",sizeToSelect)

      //this means the user changed the size manually in the result, and it is what we are going to use to select the variant
      //if( !sizes.options[sizes.selectedIndex].value.includes("Size " + selectedSize) ){
        sizeToSelect = sizes.options[sizes.selectedIndex].value
      //}      
      //console.log("sizeToSelect",sizeToSelect,"selectedPack",selectedPack)
      
      //change size => change variant
      if(sizes && packs) variants.value = Array.from(variants).find( variant => {return variant.dataset.size.includes(sizeToSelect) && variant.dataset.packs === selectedPack} )?.value
      if(!sizes) variants.value = Array.from(variants).find( variant => { return variant.dataset.packs === selectedPack } )?.value
      if(!packs) variants.value = Array.from(variants).find( variant => { return variant.dataset.size === sizeToSelect } )?.value
      
      variants.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  if(purchaseTypes){
    purchaseTypes.addEventListener('change', () => {
      //disable + hide OR enable + show selling plan
      if(purchaseTypes.value=="subscription"){
        frequencies.closest('.product-form__input--dropdown').style.display = 'block'
        sellingPlans.closest('.product-form__input--dropdown').style.display = 'block'
        sellingPlans.disabled = false
      } else {
        frequencies.closest('.product-form__input--dropdown').style.display = 'none'
        sellingPlans.closest('.product-form__input--dropdown').style.display ='none'
        sellingPlans.disabled = true
      }

      const selectedVariant = result.querySelector('[name="id"] option:checked')
      if(!selectedVariant) return
      let variantPrice = selectedVariant.dataset.price
      let variantCompareAtPrice = selectedVariant.dataset.compareat
      const resultPrice = result.querySelector('.multistep-result__price')
      
      //adjusting the price if it is a subscription
      if(sellingPlans && purchaseTypes && purchaseTypes.value == "subscription"){
        const selectedPlan = result.querySelector('[name="selling-plans"] option:checked')
        if(selectedPlan.dataset.adjustment && selectedPlan.dataset.adjustment > 0) variantPrice = variantPrice * selectedPlan.dataset.adjustment 
      }
  
      if(variantCompareAtPrice) variantCompareAtPrice = window.moneyFormat.replace("{{amount}}",(variantCompareAtPrice / 100).toFixed(2))
      variantPrice = window.moneyFormat.replace("{{amount}}",(variantPrice / 100).toFixed(2))
    
      //change variant => change price
      resultPrice.innerHTML = (variantCompareAtPrice)?`<span class="price-strike">${variantCompareAtPrice}</span>${variantPrice}`:variantPrice;
    })
  }  
  
  if(frequencies){
    frequencies.addEventListener('change', () => {
      //change selling plan
      sellingPlans.value = Array.from(sellingPlans).find( sellingPlan => { return sellingPlan.text?.includes(" " + selectedDelivery + " " ) })?.value      
    })
  }
  //Individual ATC Button
  buttonAtc.addEventListener('click', () => {
    var cartItems = [];
    let cartItem = {}
    if(sellingPlans && !sellingPlans.disabled && sellingPlans.value){
      cartItem = {
        id: variants.value,
        quantity: quantity.value,
        selling_plan: sellingPlans.value
      }
    } else {
      cartItem = {
        id: variants.value,
        quantity: quantity.value,
      }
    }  
    cartItems.push(cartItem)
    var cartData = {
      items: cartItems,
      attributes:{
      }
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },        
      body: JSON.stringify(cartData)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      //console.log('Product added to cart:', data);
      //TODO: better response
      //alert('Product added to cart')
      const cartNotification = document.querySelector('#cart-notification')
      if(cartNotification) {
        cartNotification.classList.add('active')
        cartNotification.classList.add('animate')
      }
    })
    .catch(function(error) {
      console.error('Error adding product to cart:', error);
    });

  })
})

//make sure we start at step 1
if (currentStep < 0) {
  currentStep = 0
  showCurrentStep()
}

//PREV NEXT buttons
multiStepForm.addEventListener("click", e => {
  let incrementor
  if (e.target.matches("[data-next]")) {
    incrementor = 1
  } else if (e.target.matches("[data-previous]")) {
    incrementor = -1
  }

  if (incrementor == null) return

  const inputs = [...formSteps[currentStep].querySelectorAll("input")]
  const allValid = inputs.every(input => input.reportValidity())
  if (allValid) {
    currentStep += incrementor
    showCurrentStep()
    scrollToTop()
  }
})

//Clicking previous in the results: hide the results and show the steps (last step)
document.querySelector('.bundle-results [data-previous]').addEventListener('click', () => {
  document.querySelector('.bundle-results').style.display = 'none'
  document.querySelector('.bundle-questions').style.display = 'flex'
  document.querySelector('.bundle-results .multistep-card').classList.remove('active')
  currentStep--;
  showCurrentStep()
})

//show/hide steps after animation
formSteps.forEach(step => {
  step.addEventListener("animationend", e => {
    formSteps[currentStep].classList.remove("hide")
    e.target.classList.toggle("hide", !e.target.classList.contains("active"))
  })
})

function showCurrentStep() {
  document.querySelector('.bundle-results').style.display = 'none'
  document.querySelector('.bundle-questions').style.display = 'flex'
  
  formSteps.forEach((step, index) => {
    step.classList.toggle("active", index === currentStep)
  })
  if(currentStep == 5){
    document.querySelector('.bundle-results').style.display = 'block'
    document.querySelector('.bundle-questions').style.display = 'none'
    document.querySelector('.bundle-results .multistep-card').classList.add('active')
  }
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}


